import {
  ConfigApi,
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import {
  FigmaUpdateData,
  FigmaUpdateRecord,
  GetFigmaUpdateRequest,
  GetFigmaUpdateResponse,
} from '../types';

type Options = {
  discoveryApi: DiscoveryApi;
  configApi: ConfigApi;
  fetchApi: FetchApi;
};

export const figmaApiRef = createApiRef<FigmaAPI>({
  id: 'plugin.figma.service',
});

export class FigmaAPI {
  private readonly backendUrl: string | undefined;
  private readonly fetchApi: FetchApi;

  constructor(options: Options) {
    this.backendUrl = options.configApi.getOptionalString('backend.baseUrl');
    this.fetchApi = options.fetchApi;
  }

  private async getUrls() {
    return `${this.backendUrl}/api/figma/proxy`;
  }

  /**
   * Get Figma Update
   */

  async getFigmaUpdates(
    params: GetFigmaUpdateRequest,
  ): Promise<FigmaUpdateData> {
    try {
      const baseUrl = await this.getUrls();
      const apiUrl = `${baseUrl}/updates?fileKey=${params.fileKey}&nodeIds=${params.nodeIds}`;

      const response = await this.fetchApi.fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(
          `Failed to fetch figma updates: ${response.statusText}`,
        );
      }

      const data: GetFigmaUpdateResponse = await response.json();
      const mappedData: FigmaUpdateData = {
        ...data,
        records: Object.values(data.records)
          .filter(record => record !== null)
          .map((record: FigmaUpdateRecord | null) => ({
            link: `https://www.figma.com/design/${
              data.file_key
            }/${data.file_name.replace(
              /\s/g,
              '-',
            )}?node-id=${record?.node_id.replace(':', '-')}`,
            lastUpdatedAt: record?.last_updated_at as string,
            changeSummary: record?.change_summary as string | null,
          })),
      };
      return mappedData;
    } catch (error) {
      throw new Error(`Error in getFigmaUpdates: ${error}`);
    }
  }
}
